<mat-slider
	#slider
	[min]="min"
	[max]="max"
	[step]="step"
>
	<input matSliderThumb [ngModel]="value" (ngModelChange)="emitValue($event)">
</mat-slider>
